import cogoToast from 'cogo-toast';
import errorMessageBinding from './errorMessageBinding';

export const displayInAppError = message =>
  cogoToast.error(message, {
    hideAfter: 4,
    position: 'top-right'
  });

export const displayError = statusCode =>
  cogoToast.error(errorMessageBinding[statusCode] || `Erreur ${statusCode}`, {
    hideAfter: 4,
    position: 'top-right'
  });

export const displaySuccess = (message, hideAfter = 4) =>
  cogoToast.success(message, {
    hideAfter,
    position: 'top-right'
  });

export const displayInfo = message =>
  cogoToast.info(message, {
    hideAfter: 4,
    position: 'top-right'
  });

export const displayLoading = message =>
  cogoToast.loading(message, {
    hideAfter: 0,
    position: 'top-right'
  });
